"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const utils_1 = require("../utils");
/**
 * Represents an arbiter stasis component to prevent extension components
 * from crashing the system. Shows an (optionally custom) error instead.
 */
class ArbiterStasis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
        };
    }
    componentDidCatch(error) {
        const { onError } = this.props;
        if (utils_1.isfunc(onError)) {
            onError(error);
        }
        this.setState({
            error,
        });
    }
    render() {
        const { children, renderError, renderChild, renderProps } = this.props;
        const { error } = this.state;
        if (error) {
            if (utils_1.isfunc(renderError)) {
                return renderError(error, renderProps);
            }
            return React.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, error && error.message);
        }
        return utils_1.isfunc(renderChild) ? renderChild(children, renderProps) : children;
    }
}
exports.ArbiterStasis = ArbiterStasis;
